import '@tanstack/react-router'

import { truncate } from '@/utils'

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    title?: string
    // Set when the route's component sets its own title (e.g. from loaded data),
    // so the central resolver steps aside.
    dynamicTitle?: boolean
  }
}

export const DEFAULT_DOCUMENT_TITLE = 'CounselPro'

const MAX_PROJECT_NAME_LENGTH = 16

export const projectPageTitle = (
  section: string,
  projectName?: string | null,
) =>
  projectName
    ? `${section} · ${truncate(projectName, MAX_PROJECT_NAME_LENGTH)}`
    : section
